import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';

const styles = (theme: Theme) => createStyles({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  list: {
    flexGrow: 1,
  },
  listItem: {
    cursor: 'pointer',
    color: theme.palette.grey[700],
    '&:hover': {
      '& $listItemIcon': {
        color: theme.palette.primary.main,
      },
      '& $listItemText': {
        color: theme.palette.primary.main,
      },
    },
    '& + &': {
      marginTop: theme.spacing(1),
    },
  },
  activeListItem: {
    '& $listItemText': {
      color: theme.palette.primary.main,
    },
    '& $listItemIcon': {
      color: theme.palette.primary.main,
    },
  },
  listItemText: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    marginLeft: theme.spacing(1),
    height: 24,
    marginTop: 0,
    marginBottom: 0,
  },
  listItemIcon: {
    color: theme.palette.grey[700],
    minWidth: 24,
  },
});

export default styles;
